export default "__VITE_ASSET__Bay3heWr__"